import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/referrals")({
  loader: ({ route: { fullPath } }) =>
    new Crumb({
      fullPath,
      title: (t) => t("backoffice.referrals.title"),
    }),
})
